<template>
    <div>
        <label :for="'id-'+uid" v-if="label">{{ label }}</label>
        <textarea
                :id="'id-'+uid"
                ref="input"
                type="text"
                :value="value"
                class="form-control"
                :class="{'is-invalid' : lar_errors.has(name), 'focus': value && value.length > 0}"
                @input="updateInput()"
                :rows="rows || 5"
                :placeholder="placeholder"></textarea>

        <div class="invalid-feedback" v-text="lar_errors.get(name)"></div>
    </div>
</template>

<script>
    import lar_errors from '../../helpers/Errors'

    export default {
        name: "SsInput",
        props: ['label', 'value', 'name', 'placeholder', 'rows'],
        components: lar_errors,
        data() {
            return {
                lar_errors: lar_errors,
                uid: null
            }
        },
        mounted () {
            this.uid = this._uid
        },
        methods: {
            updateInput() {
              if(lar_errors.has(this.name)){ lar_errors.clear(this.name); }
                this.$emit('input', this.$refs.input.value);
            }
        },
    }
</script>

<style scoped>

</style>
